export const PASSWORD_MESSAGES = {
	USERNAME: 'HELLO,',
	START: "Let's reset your password.",
	CONTENT: 'What would you like your new password to be?',
};

export const VALIDATION_STATUS = {
	SUCCESS: 'SUCCESS',
	LOADING: 'LOADING',
	ERROR: 'ERROR',
};
